import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx} from "../../../../api/http-post";
import {GetFieldsAdditional} from "../../../../constants";


class SettingReportDefineEmailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Modules: [],
            Entities: [],
            Attributes:[],
            isLoading: false,
            component: "list",
            newEntry: {},
            selectedCompany:"",
            selectedEntity:"",
        }
    }

    componentDidMount = async () => {

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("Projects","Projects");
        await this.loadData("Entities","Entities");
        await this.loadData("attributes","Attributes");

        /*

        await this.loadData("product","Products")
        */
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            let res=[];
            if(data!==null){
                res=data.RESULT
            }
            await _this.setState({
                [stateKey]: res
            })
        });
    }

    /*

     */
    getPrefixedListField = () => {
        let categories = this.getActivitiesOptions();
        return GetFieldsAdditional(categories);
    }
    getActivitiesOptions=()=>{
        let categories = [];
        for(let i in this.state.Entities){
            let row=this.state.Entities[i];
            if(row.org!==this.state.selectedCompany){
                continue
            }
            if(row.module!==this.state.selectedProject){
                continue
            }
            categories.push({
                key:row.name,
                val:row.name
            })
        }
        return categories
    }
    getOptionsFields=()=>{
        let options = [];
        for(let i in this.state.Attributes){
            let row=this.state.Attributes[i];
            if(row.org!==this.state.selectedCompany){
                continue
            }
            if(row.module!==this.state.selectedProject){
                continue
            }
            options.push({
                key:row.fieldname,
                val:row.fieldname
            })
        }
        return options
    }


    render() {
        let optionsFields = this.getOptionsFields();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup project email attributes</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"ContactFieldEmail"}
                            fields={[
                                {name: "fieldname", dataType: "option", required: true, label: "Field Name", options: optionsFields},
                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "module", type: "string"},
                                {key: "fieldname", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"ContactFieldEmail"}
                            addFormText={"ContactFieldEmail"}
                            stepTitle={"Set Up new Contact Field Email"}
                            displayRules={[
                                {rowKey: "org", stateKey: "selectedCompany"},
                                {rowKey: "module", stateKey: "selectedProject"}
                            ]}
                            filterByCompany={true}
                            filterByModule={true}
                            injectFields={[
                                {
                                    rowKey: "Org",
                                    stateKey: "selectedCompany",
                                    errorMsg: "Sorry you can't save, Please select your company!"
                                },
                                {
                                    rowKey: "Module",
                                    stateKey: "selectedProject",
                                    errorMsg: "Sorry you can't save, Please select your Project!"
                                },
                            ]}
                            injectStaticValue={[
                                /*{key:"category",val:"entity"}*/
                            ]}
                            extraFilters={[
                            ]}
                        />
                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(SettingReportDefineEmailPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
